import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { axiosInstance as axios } from '../../../context/AuthContext';
import { Switch } from '../../ui/switch';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';

export function PilotSettingsCard() {
  const [s, setS] = useState(null);
  const [cap, setCap] = useState(15);

  useEffect(() => {
    axios.get('/api/pilot/admin/settings').then(r => { setS(r.data); setCap(r.data.family_cap); }).catch(() => {});
  }, []);

  const save = async (families_open, family_cap) => {
    try {
      const r = await axios.put('/api/pilot/admin/settings', { families_open, family_cap: Number(family_cap) });
      setS(r.data);
      toast.success(families_open ? 'Family pilot is open' : 'Family pilot is closed');
    } catch (e) {
      toast.error(e.response?.data?.detail?.[0]?.msg || 'Could not save');
    }
  };

  if (!s) return null;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-5" data-testid="pilot-settings-card">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h3 className="text-white font-semibold">Phase 2 — Families</h3>
          <p className="text-slate-400 text-sm">
            {s.families_open
              ? `Open: families see a "Join the pilot" card. ${s.families_joined} of ${s.family_cap} spots taken.`
              : 'Closed: families see nothing yet. Turn on when you have enough interested families.'}
          </p>
        </div>
        <div className="flex items-center gap-3">
          <label className="text-slate-300 text-sm">Family spots</label>
          <Input type="number" min={1} max={500} value={cap} onChange={e => setCap(e.target.value)}
                 className="w-20 bg-slate-900 border-slate-600 text-white" data-testid="pilot-family-cap-input" />
          <Button size="sm" variant="outline" onClick={() => save(s.families_open, cap)} data-testid="pilot-cap-save-btn">Save</Button>
          <Switch checked={s.families_open} onCheckedChange={v => save(v, cap)} data-testid="pilot-families-open-switch" />
          <span className="text-sm text-slate-300">{s.families_open ? 'Open' : 'Closed'}</span>
        </div>
      </div>
    </div>
  );
}
